import React from "react";
import { Col, Row } from "react-bootstrap";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function SkeletonModalReserveItem() {
  const list = [1, 2, 3];
  return list.map((item, index) => (
    <SkeletonTheme key={index}>
      <div className="items-box mt-4 mb-4">
        <div className="items-box-header bg-white px-2 ms-2 fs-09 fw-bold">
          <Skeleton height="20px" width="200px"></Skeleton>
        </div>
        {list.map((item, index) => (
          <div className="item-box-body pt-3 px-2" key={index}>
            <div className="item-box-row px-2 selected-item my-2 pt-2 pb-2 border-bottom">
              <Row className="gx-0 mb-1">
                <Col>
                  <Skeleton height="16px" width="100px"></Skeleton>
                </Col>
                <Col
                  xs="auto"
                  className="text-center fs-075"
                  style={{ width: "60px" }}
                >
                  {/* تعداد */}
                </Col>
              </Row>
              <Row className="gx-0">
                <Col className="fs-08 my-auto  text-black-4">
                  <Skeleton height="16px" width="80%"></Skeleton>
                </Col>
                <Col xs="2" className="text-center my-auto">
                  <Skeleton height="16px" width="80%"></Skeleton>
                </Col>
                <Col className="text-center fs-085 my-auto">
                  <Skeleton height="16px" width="80%"></Skeleton>
                </Col>
                <Col xs="auto" className=" my-auto">
                  <Skeleton height="16px" width="80%"></Skeleton>
                </Col>
              </Row>
              <Row className="gx-0">
                <Col xs="3" className="fs-08 mt-1  text-black-4">
                  <Skeleton height="10px" width="80%"></Skeleton>
                </Col>
              </Row>
            </div>
          </div>
        ))}
      </div>
    </SkeletonTheme>
  ));
}
export default SkeletonModalReserveItem;
